import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { Button, DialogActions, DialogContent } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core';

import Transition from './Transition';
import AuthUserContainer from '../../containers/AuthUser';
import DownloadIcon from '@material-ui/icons/CloudDownload';
const isLocalhost = Boolean(window.location.hostname === 'localhost');

const styles = () => {
	return {
		inner: {
			padding: '40px 30px',
		},
		dialogRoot: {
			//overflow: 'visible'
			alignItems: 'end',
		},
		icon: {
			paddingRight: 5,
		},
		downloadPdfButton: {
			fontSize: 16,
			borderRadius: '100px',
			padding: '13px 45px',
			textTransform: 'uppercase',
		},
	};
};

class ImageZoomDialog extends Component {
	handleClose = () => {
		this.props.onClose();
	};

	render() {
		const { open, classes, imageUrls, tmwOrderId, accessToken } = this.props;
		const request = {
			method: 'tmw.order.downloadPdf',
			params: {
				accessToken,
				tmwOrderId,
			},
		};
		const domain = isLocalhost ? 'http://localhost:3702' : '';
		const downloadUrl = `${domain}/api?request=${JSON.stringify(request)}`;

		return (
			<Dialog
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				fullWidth={true}
				maxWidth={'md'}
				classes={{ scrollPaper: classes.dialogRoot }}
			>
				<DialogContent dividers={true} style={{ position: 'relative', padding: 5 }}>
					{!_.isEmpty(imageUrls) &&
						imageUrls.map((imageUrl) => (
							<img
								key={imageUrl}
								src={imageUrl}
								alt="zoom"
								width="100%"
								style={{ marginBottom: 20 }}
							/>
						))}
				</DialogContent>

				<DialogActions
					style={{
						position: 'relative',
						backgroundColor: '#f7f7f7',
						padding: '15px',
						justifyContent: 'flex-start',
					}}
				>
					{tmwOrderId && (
						<a
							href={downloadUrl}
							style={{ textDecoration: 'none', paddingRight: 5 }}
							target="_blank"
							rel="noreferrer noopener"
						>
							<Button variant="contained" color="primary" className={classes.downloadPdfButton}>
								<DownloadIcon className={classes.icon} />
								Download PDF Bundle
							</Button>
						</a>
					)}

					<Button
						variant="outlined"
						className={classes.dialogCloseButton}
						onClick={this.handleClose}
					>
						Close
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
}

ImageZoomDialog.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func,
	classes: PropTypes.object,
	imageUrls: PropTypes.array,
	tmwOrderId: PropTypes.number,
};
export default _.flow([withStyles(styles), AuthUserContainer])(ImageZoomDialog);
